module.exports = __webpack_public_path__ + "assets/img/user_achievement_l2.1d581817.png";